// Email Copy
document.addEventListener('DOMContentLoaded', function () {
  const emailCopyElement = document.getElementById('emailCopy')
  const mailTitle = document.getElementById('mailTitle')

  if (emailCopyElement && mailTitle) {
    const originalTitle = mailTitle.textContent
    const emailAddress = 'info@shinra-company.co.jp'
    let isClicked = false // クリック済みフラグ

    // テキストをアニメーション付きで変更する関数
    const changeTitle = (newText) => {
      const span = mailTitle.querySelector('span')
      if (span) {
        // フェードアウト + 下へ移動開始
        span.classList.add('animating')
        // テキストを同時に変更
        mailTitle.innerHTML = `<span>${newText}</span>`
        const newSpan = mailTitle.querySelector('span')
        if (newSpan) {
          // 新しいspanも初期状態（animating）から開始
          newSpan.classList.add('animating')
          // 強制的にリフローを待たせて、新しいスタイルを確定させる
          void newSpan.offsetHeight
          // フェードイン + 上へ移動開始
          newSpan.classList.remove('animating')
        }
      }
    }

    // ホバー時
    emailCopyElement.addEventListener('mouseenter', function () {
      if (!isClicked) { // クリックされていない場合のみ
        changeTitle('COPY TO CLIPBOARD?')
      }
    })

    emailCopyElement.addEventListener('mouseleave', function () {
      if (!isClicked) { // クリックされていない場合のみ
        changeTitle(originalTitle)
      }
    })

    // クリック時
    emailCopyElement.addEventListener('click', function () {
      if (isClicked) return // すでにクリック済みの場合は何もしない

      // Clipboard APIを使用してメールアドレスだけをコピー
      navigator.clipboard.writeText(emailAddress).then(() => {
        changeTitle('MAIL IS COPIED!')
        isClicked = true // クリック済みフラグを立てる
      }).catch(() => {
        // フォールバック: execCommand
        const textarea = document.createElement('textarea')
        textarea.value = emailAddress
        document.body.appendChild(textarea)
        textarea.select()
        // @ts-ignore
        document.execCommand('copy')
        document.body.removeChild(textarea)

        changeTitle('MAIL IS COPIED!')
        isClicked = true // クリック済みフラグを立てる
      })
    })
  }
})

// TitleText と ScrollGuide のスクロール連動（PC のみ）
const mainVisual = document.querySelector('.mainVisual')
const titleText = mainVisual?.querySelector('.titleText')
const scrollGuide = mainVisual?.querySelector('.scrollGuide')

if (titleText || scrollGuide) {
  const setPosition = () => {
    if (window.innerWidth <= 768) {
      if (titleText) titleText.style.position = ''
      if (scrollGuide) scrollGuide.style.position = ''
      return
    }
    const isFixed = mainVisual.getBoundingClientRect().bottom > window.innerHeight
    if (titleText) titleText.style.position = isFixed ? 'fixed' : ''
    if (scrollGuide) scrollGuide.style.position = isFixed ? 'fixed' : ''
  }

  document.addEventListener('scroll', setPosition)
  window.addEventListener('resize', setPosition)
  setPosition()
}